// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.04 12.84L8.43 14.15C8.14 14.38 8 14.32 8 13.95L8 10.8M8 5.2L8 2.05C8 1.68 8.14 1.62 8.43 1.85L11.57 4.4C11.86 4.63 11.86 4.87 11.57 5.1L9.54 6.74M6.46 9.26L4 11.25',
  'M2 2L14 14',
];
